(function() {
  var input = document.querySelector('.quantity__input[data-min]');
  if (!input) return;
  var min = parseInt(input.getAttribute('min')) || 1;

  input.addEventListener('change', function() {
    if (parseInt(this.value) < min) {
      this.value = min;
    }
  });

  var formId = input.getAttribute('form');
  var form = formId ? document.getElementById(formId) : input.closest('form');
  if (form) {
    form.addEventListener('submit', function(e) {
      if (parseInt(input.value) < min) {
        e.preventDefault();
        input.value = min;
        input.focus();
      }
    });
  }
})();